var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H11.5882H8.47059C7.9183 20 7.47059 19.5523 7.47059 19V14.0969C7.47059 13.7185 7.16384 13.4118 6.78545 13.4118C6.15753 13.4118 5.86038 12.6374 6.32711 12.2174L12.5663 6.60207C12.9466 6.25979 13.524 6.25979 13.9043 6.60207L20.1435 12.2174C20.6102 12.6374 20.3131 13.4118 19.6851 13.4118C19.3067 13.4118 19 13.7185 19 14.0969V19C19 19.5523 18.5523 20 18 20Z",
    fill: "#1756E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1566 12H12.3134V13.8419L10.4705 13.8419V15.6851H12.3134V17.5296H14.1566V15.6851H16.0001V13.8419L14.1566 13.8419V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOutline);
export default __webpack_public_path__ + "static/media/homeOutline.13b67a7edc979104a71d19a4c1041b7a.svg";
export { ForwardRef as ReactComponent };